export const NuxtApollo = {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true, "sameSite": "lax"},
 clients: {"default": {"httpEndpoint": "https://dygmajkpwnb7fjgfvgehztugz4.appsync-api.eu-west-2.amazonaws.com/graphql", "httpLinkOptions": {"headers": {"x-api-key": "da2-6rfq2igdvrerbivsrhanuzsksq"}}, "authType": "Bearer", "authHeader": "Authorization", "tokenName": "apollo:default.token", "tokenStorage": "cookie", "defaultOptions": undefined}}
}